import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
  PutRequestArgsType,
  DeleteRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetTeamTenantUsersArgsType = GetRequestArgsType & {
  teamCode: string;
};

export type PostTeamTenantUserPayloadType = {
  tenantUserId: number;
  teamMemberRoleId: number;
};

export type PostTeamTenantUserArgsType = PostRequestArgsType<PostTeamTenantUserPayloadType> & {
  teamCode: string;
};

export type PutTeamTenantUserPayloadType = {
  teamMemberRoleId: number;
};

export type PutTeamTenantUserArgsType = PutRequestArgsType<PutTeamTenantUserPayloadType> & {
  teamCode: string;
  teamTenantUserId: number;
};

export type DeleteTeamTenantUserArgsType = DeleteRequestArgsType & {
  teamCode: string;
  teamTenantUserId: number;
};

export const apiFetchTeamTenantUsers = async ({
  domain = useTenantStore().domain,
  teamCode,
  errorConfig = {},
  callbacks = {},
}: GetTeamTenantUsersArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.teamTenantUsers({ domain, teamCode }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCreateTeamTenantUser = async ({
  domain = useTenantStore().domain,
  teamCode,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostTeamTenantUserArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.teamTenantUsers({ domain, teamCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiUpdateTeamTenantUser = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamTenantUserId,
  payload,
  errorConfig = {},
  callbacks = {},
}: PutTeamTenantUserArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.teamTenantUsers({
        domain,
        teamCode,
        teamTenantUserId,
      }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteTeamTenantUser = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamTenantUserId,
  errorConfig = {},
  callbacks = {},
}: DeleteTeamTenantUserArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.teamTenantUsers({ domain, teamCode, teamTenantUserId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
